<template>
    <div class="flex items-center justify-center">
        <span class="time">{{ timerDisplayTime }}</span>
        <VcPopover
            v-if="virtualHoldJoinTimeStamp"
        >
            <template #reference>
                <span class="time">({{ virtualHoldJoinDifference }})</span>
            </template>
            <span>
                {{ t('widget.virtualHoldWaitTimeDescription') }}
            </span>
        </VcPopover>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { QueueCallSDK } from '@voicenter-team/events-sdk'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'
import { useTimer } from '@/composables/useTimer'
import { timeFormatter } from '@/helpers/timeFormatter'

const { t } = useI18n()

const props = withDefaults(
    defineProps<{
        call: QueueCallSDK,
        textColor?: string
    }>(),
    {
        textColor: 'text-gray-500'
    }
)

const queueJoinTimeStamp = computed(() => {
    return props.call.JoinTimeStamp_UTC_CLIENT
})

const virtualHoldJoinTimeStamp = computed(() => {
    return props.call.VHJoinTimeStamp_UTC_CLIENT ?? 0
})

const virtualHoldJoinDifference = computed(() => {
    return timeFormatter((virtualHoldJoinTimeStamp.value / 1000) - (queueJoinTimeStamp.value / 1000))
})

const {
    timerDisplayTime,
    startTimer,
} = useTimer(false)

startTimer(queueJoinTimeStamp)
</script>

<style scoped>
.time {
    font-variant-numeric: tabular-nums;
    @apply font-medium tracking-wide;
}
</style>
